<template>
  <div>
    <a-steps :current="currentStep">
      <a-step v-for="item in steps" :key="item.title" :title="item.title" />
    </a-steps>
    <div style="margin-top: 32px">
      <!-- 1、查询作者 -->
      <div class="step-item" v-if="currentStep == 0">
        <a-row>
          <a-col
            :span="3"
            style="
              height: 32px;
              line-height: 32px;
              text-align: right;
              padding-right: 5px;
            "
            >查询作者：
          </a-col>
          <a-col :span="10">
            <a-select
              v-model="selAuthorCode"
              show-search
              placeholder="请输入作者姓名搜索"
              style="width: 100%"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              not-found-content="未找到作者信息"
              @search="handleSearchAuthor"
              @change="handleChangeAuthor"
            >
              <a-select-option
                v-for="item in authorList"
                :key="item.authorCode"
              >
                {{ `${item.authorName}（${item.phone}）${item.companyName}` }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :offset="1" :span="2">
            <a-button type="primary" @click="addAuthor('add')"
              >新增作者</a-button
            >
          </a-col>
        </a-row>
        <a-row style="margin-top: 24px" v-if="!selAuthorCode">
          <a-empty description="暂无作者信息" />
        </a-row>
        <a-row style="margin-top: 24px" v-if="selAuthorCode">
          <a-col :offset="3" :span="9">
            <a-descriptions title="作者信息" :column="1">
              <a-descriptions-item label="姓名">
                {{ selAuthor.authorName }}
              </a-descriptions-item>
              <a-descriptions-item label="性别">
                {{ selAuthor.sex == 0 ? "女" : selAuthor.sex == 1 ? "男" : "" }}
              </a-descriptions-item>
              <a-descriptions-item label="出生年月">
                {{ selAuthor.birth }}
              </a-descriptions-item>
              <a-descriptions-item label="联系电话">
                {{ selAuthor.phone }}
              </a-descriptions-item>
              <a-descriptions-item label="所在省市">
                {{ selAuthor.province + selAuthor.city }}
              </a-descriptions-item>
              <a-descriptions-item label="单位名称">
                {{ selAuthor.companyName }}
              </a-descriptions-item>
              <a-descriptions-item label="单位地址">
                {{ selAuthor.companyAddress }}
              </a-descriptions-item>
              <a-descriptions-item label="邮政编码">
                {{ selAuthor.postCode }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
          <a-col :offset="2" :span="10">
            <a-descriptions title="银行卡信息" :column="1">
              <a-descriptions-item label="开户行">
                {{ bankCard.openBank }}
              </a-descriptions-item>
              <a-descriptions-item label="开户行号">
                {{ bankCard.bankCode }}
              </a-descriptions-item>
              <a-descriptions-item label="银行卡号">
                {{ bankCard.bankCard }}
              </a-descriptions-item>
              <a-descriptions-item label="身份证号">
                {{ bankCard.idCard }}
              </a-descriptions-item>
              <a-descriptions-item label="">
                <a-button type="primary" @click="selectBankCard"
                  >选择银行卡</a-button
                >
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
        </a-row>
      </div>

      <!-- 2、上传稿件和稿件信息 -->
      <div class="step-item" v-if="currentStep == 1">
        <a-tabs defaultActiveKey="1">
          <!-- 稿件信息 -->
          <a-tab-pane tab="稿件信息" key="1">
            <a-form-model
              ref="manuscriptForm"
              :model="manuscript"
              :rules="manuscriptRules"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 14 }"
            >
              <a-form-model-item label="上传稿件">
                <a-upload
                  name="file"
                  :fileList="fileList"
                  :action="serviceAddress"
                  :headers="headers"
                  @change="uploadFile"
                  @preview="previewFile"
                  :data="data"
                  accept=".docx"
                >
                  <a-button> <a-icon type="upload" />选择文件 </a-button>
                </a-upload>
              </a-form-model-item>
              <a-form-model-item label="标题" prop="cnTitle">
                <a-input
                  v-model="manuscript.cnTitle"
                  placeholder="请输入"
                  :maxLength="50"
                />
              </a-form-model-item>
              <a-form-model-item label="副标题" prop="subtitle">
                <a-input
                  v-model="manuscript.subtitle"
                  placeholder="请输入"
                  :maxLength="50"
                />
              </a-form-model-item>
              <a-form-model-item label="摘要" prop="summary">
                <a-textarea
                  placeholder="请输入"
                  v-model="manuscript.summary"
                  :autoSize="{ minRows: 3, maxRows: 5 }"
                  :maxLength="480"
                />
              </a-form-model-item>
              <a-form-model-item label="关键词" prop="keyWords">
                <a-input
                  v-model="manuscript.keyWords"
                  placeholder="请输入"
                  :maxLength="50"
                />
              </a-form-model-item>
              <a-form-model-item label="课题信息" prop="subjectInfo">
                <a-textarea
                  placeholder="请输入"
                  v-model="manuscript.subjectInfo"
                  :autoSize="{ minRows: 2, maxRows: 2 }"
                  :maxLength="200"
                />
              </a-form-model-item>
              <a-form-model-item label="参考文献" prop="referencesInfo">
                <a-textarea
                  placeholder="请输入"
                  v-model="manuscript.referencesInfo"
                  :autoSize="{ minRows: 2, maxRows: 4 }"
                  :maxLength="380"
                />
              </a-form-model-item>
              <a-form-model-item label="版本" prop="sectionInfo">
                <a-select
                  v-model="manuscript.sectionInfo"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="onSectionChange"
                >
                  <a-select-option
                    :value="item.dicValue"
                    v-for="item in sectionInfos"
                    :key="item.dicValue"
                    >{{ item.dicValue }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
              <a-form-model-item label="栏目" prop="columnInfo">
                <a-select
                  style="width: 100%"
                  placeholder="请选择"
                  v-model="manuscript.columnInfo"
                >
                  <a-select-option
                    v-for="item in columnInfos"
                    :value="item.columnName"
                    :key="item.columnName"
                  >
                    {{ item.columnName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item
                label="学科"
                prop="discipline"
                v-if="disciplines.length > 0"
              >
                <a-select
                  v-model="manuscript.discipline"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <a-select-option
                    :value="item.dicValue"
                    v-for="item in disciplines"
                    :key="item.dicValue"
                    >{{ item.dicValue }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
              <a-form-model-item label="字数" prop="wordCount" required>
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="manuscript.wordCount"
                  v-bind:read-only="true"
                />
              </a-form-model-item>
              <a-form-model-item label="备注" prop="note">
                <a-textarea
                  placeholder="请输入"
                  class="textarea"
                  v-model="manuscript.note"
                  :autoSize="{ minRows: 2, maxRows: 2 }"
                  :maxLength="100"
                />
              </a-form-model-item>
            </a-form-model>
          </a-tab-pane>
          <!-- 作者信息 -->
          <a-tab-pane tab="作者信息" key="2" forceRender>
            <a-button @click="addAuthor('manuscript')">添加作者</a-button>
            <template>
              <a-table
                :columns="columns"
                :dataSource="authorData"
                :rowKey="(record) => record.authorSort"
                size="small"
                :pagination="false"
                style="margin-top: 10px"
              >
                <span slot="corAuthor" slot-scope="text, record">
                  <label v-if="record.corAuthor == 1">是</label>
                  <label v-if="record.corAuthor == 0">否</label>
                </span>
                <span slot="operator" slot-scope="text, record">
                  <a
                    v-if="record.authorSort != 1"
                    href="javascript:void(0);"
                    @click="() => orderUp(record.authorSort)"
                  >
                    上移
                  </a>
                  <a-divider type="vertical" v-if="record.authorSort != 1" />
                  <a
                    v-if="record.authorSort != authorData.length"
                    href="javascript:void(0);"
                    @click="() => orderDown(record.authorSort)"
                  >
                    下移
                  </a>
                  <a-divider
                    type="vertical"
                    v-if="record.authorSort != authorData.length"
                  />
                  <a
                    href="javascript:void(0);"
                    @click="() => editAuthor(record)"
                  >
                    编辑
                  </a>
                  <a-divider type="vertical" />
                  <a-popconfirm
                    title="确认要删除该作者吗?"
                    @confirm="deleteAuthor(record)"
                  >
                    <a href="javascript:void(0);">删除</a>
                  </a-popconfirm>
                </span>
              </a-table>
            </template>
          </a-tab-pane>
        </a-tabs>
      </div>
      <!-- 3、确认提交 -->
      <div class="step-item" v-if="currentStep == 2">
        <!-- 稿件信息 -->
        <a-row>
          <a-descriptions title="稿件信息" :column="2">
            <a-descriptions-item label="标题">
              {{ manuscript.cnTitle }}
            </a-descriptions-item>
            <a-descriptions-item label="副标题">
              {{ manuscript.subtitle }}
            </a-descriptions-item>
            <a-descriptions-item label="摘要">
              {{ manuscript.summary }}
            </a-descriptions-item>
            <a-descriptions-item label="关键词">
              {{ manuscript.keyWords }}
            </a-descriptions-item>
            <a-descriptions-item label="课题信息">
              {{ manuscript.subjectInfo }}
            </a-descriptions-item>
            <a-descriptions-item label="参考文献">
              {{ manuscript.referencesInfo }}
            </a-descriptions-item>
            <a-descriptions-item label="版本">
              {{ manuscript.sectionInfo }}
            </a-descriptions-item>
            <a-descriptions-item label="栏目">
              {{ manuscript.columnInfo }}
            </a-descriptions-item>
            <a-descriptions-item label="学科">
              {{ manuscript.discipline }}
            </a-descriptions-item>
            <a-descriptions-item label="字数">
              {{ manuscript.wordCount }}
            </a-descriptions-item>
            <a-descriptions-item label="备注" :span="2">
              {{ manuscript.note }}
            </a-descriptions-item>
            <a-descriptions-item label="稿件">
              <a-button type="link" @click="downloadFile(fileList[0].url)">
                {{ fileList[0].name }}
              </a-button>
            </a-descriptions-item>
          </a-descriptions>
        </a-row>
        <a-row>
          <a-descriptions title="作者信息" :column="1">
            <a-descriptions-item>
              <template>
                <a-table
                  :columns="columns.filter((item) => item.key != 'operator')"
                  :dataSource="authorData"
                  :rowKey="(record) => record.authorSort"
                  size="small"
                  :pagination="false"
                >
                  <span slot="corAuthor" slot-scope="text, record">
                    <label v-if="record.corAuthor == 1">是</label>
                  </span>
                </a-table>
              </template>
            </a-descriptions-item>
          </a-descriptions>
        </a-row>
        <a-row>
          <a-descriptions title="银行卡信息" :column="2">
            <a-descriptions-item label="开户行">
              {{ bankCard.openBank }}
            </a-descriptions-item>
            <a-descriptions-item label="开户行号">
              {{ bankCard.bankCode }}
            </a-descriptions-item>
            <a-descriptions-item label="银行卡号">
              {{ bankCard.bankCard }}
            </a-descriptions-item>
            <a-descriptions-item label="身份证号">
              {{ bankCard.idCard }}
            </a-descriptions-item>
          </a-descriptions>
        </a-row>
        <a-alert
          message="提示"
          description="请确认稿件信息和作者信息是否填写完整！"
          type="warning"
          show-icon
        />
      </div>
    </div>
    <div style="text-align: right; margin-top: 12px">
      <a-button
        type="primary"
        @click="previous"
        v-if="currentStep > 0"
        :disabled="isloading"
      >
        上一步
      </a-button>
      <a-button
        type="primary"
        @click="next"
        v-if="currentStep < steps.length - 1"
        style="margin-left: 16px"
        >下一步</a-button
      >
      <a-popconfirm title="确认提交此稿件吗?" @confirm="submit">
        <a-button
          type="primary"
          v-if="currentStep == steps.length - 1"
          style="margin-left: 16px"
          :loading="isloading"
        >
          提交
        </a-button>
      </a-popconfirm>
    </div>
    <!-- 添加作者 -->
    <a-modal
      :title="modelTitle"
      v-model="visible"
      width="800px"
      @ok="authorSubmit"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <a-form-model
        ref="newAuthorForm"
        :model="authorInfo"
        :rules="authorInfoRules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 15 }"
      >
        <a-form-model-item label="作者姓名" prop="authorName">
          <a-input v-model="authorInfo.authorName" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item
          label="通讯作者"
          v-if="addAuthorType == 'manuscript'"
        >
          <a-switch :checked="authorInfo.corAuthor == 1" @change="isCor" />
        </a-form-model-item>
        <a-form-model-item label="性别" prop="sex">
          <a-radio-group v-model="authorInfo.sex">
            <a-radio :value="1">男</a-radio>
            <a-radio :value="0">女</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="出生年月" prop="birth">
          <a-month-picker v-model="authorInfo.birth" valueFormat="YYYY-MM" />
        </a-form-model-item>
        <a-form-model-item label="职称" prop="professionalTitle">
          <a-input
            v-model="authorInfo.professionalTitle"
            placeholder="请输入"
          />
        </a-form-model-item>
        <a-form-model-item label="研究方向" prop="studyDirection">
          <a-input v-model="authorInfo.studyDirection" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="所在省市" prop="city">
          <a-row>
            <a-col :span="12">
              <a-select
                v-model="authorInfo.province"
                @change="handleProvinceChange"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="val in provinces"
                  :value="val.name"
                  :key="val.name"
                >
                  {{ val.name }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="12">
              <a-select v-model="authorInfo.city" placeholder="请选择">
                <a-select-option
                  v-for="item in cities"
                  :value="item.name"
                  :key="item.name"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </a-form-model-item>
        <a-form-model-item label="邮政编码" prop="postCode">
          <a-input v-model="authorInfo.postCode" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="单位名称" prop="companyName">
          <a-input v-model="authorInfo.companyName" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="单位地址" prop="companyAddress">
          <a-input v-model="authorInfo.companyAddress" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="phone">
          <a-input v-model="authorInfo.phone" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="email" prop="email">
          <a-input v-model="authorInfo.email" placeholder="请输入" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 添加银行卡 -->
    <a-modal
      title="添加银行卡"
      v-model="bankCardVisible"
      width="800px"
      @ok="bankCardSubmit"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <a-form-model
        ref="newBankCardForm"
        :model="newBankCard"
        :rules="newBankCardRules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="开户行" prop="openBank">
          <a-input v-model="newBankCard.openBank" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="开户行号" prop="bankCode">
          <a-input v-model="newBankCard.bankCode" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="银行卡号" prop="bankCard">
          <a-input v-model="newBankCard.bankCard" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="身份证号" prop="idCard">
          <a-input v-model="newBankCard.idCard" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="默认账号">
          <a-switch v-model="newBankCard.isDefault" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 选择银行卡 -->
    <a-modal
      title="选择银行卡"
      v-model="selectCardVisible"
      width="800px"
      @ok="selectCardSubmit"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <a-button type="primary" @click="addBankCard">添加银行卡</a-button>
      <a-table
        style="margin-top: 16px"
        rowKey="id"
        size="small"
        bordered
        :columns="selectCardColumns"
        :data-source="authorBankCards"
        :rowSelection="{
          type: 'radio',
          selectedRowKeys: selBankCards,
          onChange: (selectedRowKeys, selectedRows) => {
            selBankCards = selectedRowKeys;
            manuscript.bankCardId = selectedRowKeys[0];
          },
        }"
      >
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import qs from "qs";
import cityData from "@/assets/js/city.js";

export default {
  name: "ImportManuscript",
  data() {
    return {
      currentStep: 0,
      steps: [
        {
          title: "作者确认",
        },
        {
          title: "稿件上传",
        },
        {
          title: "确认提交",
        },
      ],
      searchTimeOut: null,
      // 选择作者
      authorList: [],
      selAuthorCode: undefined,
      selAuthor: { province: "", city: "" },
      serviceAddress: this.$config.serviceAddress + "/file/upload",
      headers: {
        authorization: "authorization-text",
      },
      data: {
        fileType: "manuscripts",
      },
      //稿件信息
      fileList: [],
      manuscript: {
        cnTitle: "",
        subtitle: "",
        summary: "",
        keyWords: "",
        subjectInfo: "",
        referencesInfo: "",
        wordCount: "",
        note: "",
        sectionInfo: "",
        columnInfo: "",
        discipline: "",
      },
      manuscriptRules: {
        cnTitle: [{ required: true, message: "请输入标题", trigger: "blur" }],
        summary: [{ required: true, message: "请输入摘要", trigger: "blur" }],
        keyWords: [
          { required: true, message: "请输入关键词", trigger: "blur" },
        ],
        subjectInfo: [
          { required: false, message: "请输入课题信息", trigger: "blur" },
        ],
        referencesInfo: [
          { required: false, message: "请输入参考文献", trigger: "blur" },
        ],
        sectionInfo: [
          { required: true, message: "请选择版本", trigger: "change" },
        ],
        columnInfo: [
          { required: true, message: "请选择栏目", trigger: "change" },
        ],
        discipline: [
          { required: false, message: "请选择学科", trigger: "change" },
        ],
      },
      //稿件作者
      authorData: [],
      columns: [
        {
          title: "作者顺序",
          dataIndex: "sort",
          width: 110,
        },
        {
          title: "通讯作者",
          dataIndex: "corAuthor",
          width: 100,
          scopedSlots: { customRender: "corAuthor" },
        },
        {
          title: "姓名",
          dataIndex: "authorName",
          width: 120,
        },
        // {
        //   title: '职称',
        //   width: '6%',
        //   dataIndex: 'professionalTitle',
        //   key: 'professionalTitle'
        // },
        // {
        //   title: '研究方向',
        //   width: '10%',
        //   dataIndex: 'studyDirection',
        //   key: 'studyDirection'
        // },
        {
          title: "单位名称",
          dataIndex: "companyName",
        },
        {
          title: "单位地址",
          dataIndex: "companyAddress",
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          width: 150,
        },
        {
          title: "Email",
          dataIndex: "email",
        },
        {
          title: "操作",
          width: 220,
          key: "operator",
          scopedSlots: { customRender: "operator" },
        },
      ],
      sectionInfos: [], //版本
      allColumnInfos: [],
      columnInfos: [],
      disciplines: [], //学科
      //添加作者
      provinces: cityData,
      cities: [],
      authorInfo: {
        authorName: "",
        sex: 1,
        birth: "",
        professionalTitle: "", //职称
        studyDirection: "", //研究方向
        province: "",
        city: "",
        postCode: "",
        companyName: "",
        companyAddress: "",
        phone: "",
        email: "",
        corAuthor: 0,
      },
      authorInfoRules: {
        authorName: [
          { required: true, message: "请输入作者姓名", trigger: "blur" },
        ],
        birth: [
          { required: true, message: "请选择出生年月", trigger: "change" },
        ],
        postCode: [
          { required: true, message: "请输入邮政编码", trigger: "blur" },
        ],
        city: [{ required: true, message: "请选择省市", trigger: "change" }],
        companyName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        companyAddress: [
          { required: true, message: "请输入单位地址", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
      },
      addAuthorType: "",
      modelTitle: "",
      visible: false,
      // 银行卡
      authorBankCards: [],
      bankCard: {
        id: 0,
        openBank: "",
        bankCode: "",
        bankCard: "",
        idCard: "",
        isDefault: true,
      },
      bankCardVisible: false,
      selectCardVisible: false,
      selBankCards: [],
      newBankCard: {
        id: 0,
        openBank: "",
        bankCode: "",
        bankCard: "",
        idCard: "",
        isDefault: true,
        newCard: true,
      },
      newBankCardRules: {
        openBank: [
          { required: true, message: "请输入开户行", trigger: "blur" },
        ],
        bankCode: [
          { required: true, message: "请输入开户行号", trigger: "blur" },
        ],
        bankCard: [
          { required: true, message: "请输入银行卡号", trigger: "blur" },
        ],
        idCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
      },
      selectCardColumns: [
        {
          title: "开户行",
          dataIndex: "openBank",
          key: "openBank",
        },
        {
          title: "开户行号",
          dataIndex: "bankCode",
          key: "bankCode",
        },
        {
          title: "银行卡号",
          dataIndex: "bankCard",
          key: "bankCard",
        },
        {
          title: "身份证号",
          dataIndex: "idCard",
          key: "idCard",
        },
      ],
      isloading: false,
    };
  },
  created() {
    this.axios
      .get("/dataDic/queryChild", { params: { parentCode: "section_info" } })
      .then((res) => {
        if (res.data) {
          this.sectionInfos = res.data;
        } else {
          this.utils.messageInfo(this, "error", "查询刊物版本失败！");
        }
      });
    this.axios.get("/columnInfo/listColumns").then((res) => {
      if (res.data) {
        this.allColumnInfos = [...res.data];
      } else {
        this.utils.messageInfo(this, "error", "查询刊物版本失败！");
      }
    });
    // this.axios
    //   .get("/dataDic/queryChild", { params: { parentCode: "discipline" } })
    //   .then((res) => {
    //     if (res.data) {
    //       this.disciplines = res.data;
    //     } else {
    //       this.utils.messageInfo(this, "error", "查询刊物学科失败！");
    //     }
    //   });
  },
  mounted() {},
  methods: {
    handleSearchAuthor(val) {
      let _this = this;
      if (_this.searchTimeOut) {
        clearTimeout(_this.searchTimeOut);
        _this.searchTimeOut = null;
      }

      function getAudit() {
        _this.authorList = [];
        _this.selAuthorCode = undefined;
        _this.selAuthor = {};
        _this.bankCard = {};
        if (val) {
          _this.axios
            .get("/author/queryAuthor", {
              params: {
                authorName: val,
                sortField: "create_time",
                sortType: "desc",
                page: 1,
                limit: 20,
                time: new Date().getTime(),
              },
            })
            .then((res) => {
              if (res.data.code == "0") {
                _this.authorList = res.data.data;
              } else {
                _this.utils.messageInfo(_this, "error", "查询作者列表失败！");
              }
            });
        }
      }

      _this.searchTimeOut = setTimeout(getAudit, 300);
    },
    handleChangeAuthor(val) {
      this.selAuthorCode = val;
      this.selAuthor = this.authorList.find((item) => item.authorCode == val);
      this.getAuthorCard();
    },
    getAuthorCard() {
      this.bankCard = {};
      this.axios
        .get("/author/getAuthorBankCard", {
          params: {
            authorCode: this.selAuthorCode,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.authorBankCards = res.data.data;
            if (this.authorBankCards && this.authorBankCards.length > 0) {
              var cardInfo = this.authorBankCards.find(
                (item) => item.isDefault == 1
              );
              if (!cardInfo) {
                cardInfo = this.authorBankCards[0];
              }
              this.bankCard.id = cardInfo.id;
              this.bankCard.openBank = cardInfo.openBank;
              this.bankCard.bankCode = cardInfo.bankCode;
              this.bankCard.bankCard = cardInfo.bankCard;
              this.bankCard.idCard = cardInfo.idCard;
              this.bankCard.isDefault = cardInfo.isDefault == 1;
              this.manuscript.bankCardId = cardInfo.id;
              this.selBankCards = [cardInfo.id];
            }
          } else {
            this.utils.messageInfo(this, "error", "查询作者信息失败！");
          }
        });
    },
    selectBankCard() {
      this.selectCardVisible = true;
    },
    selectCardSubmit() {
      var findCard = this.authorBankCards.find(
        (item) => item.id == this.manuscript.bankCardId
      );
      this.bankCard = { ...findCard };
      this.selectCardVisible = false;
    },
    addBankCard() {
      this.newBankCard.id = Math.random() * (9000000 - 100000000) + 100000000;
      this.bankCardVisible = true;
    },
    bankCardSubmit() {
      this.$refs.newBankCardForm.validate((valid) => {
        if (valid) {
          this.authorBankCards.push({ ...this.newBankCard });
          this.manuscript.bankCardId = this.newBankCard.id;
          this.selBankCards = [this.newBankCard.id];
          this.newBankCard = {
            id: 0,
            openBank: "",
            bankCode: "",
            bankCard: "",
            idCard: "",
            isDefault: true,
            newCard: true,
          };
          this.bankCardVisible = false;
        }
      });
    },
    handleProvinceChange(value) {
      this.cities = cityData.find((item) => item.name == value).children;
      this.authorInfo.city = this.cities[0].name;
    },
    uploadFile(info) {
      this.fileList = [info.file];
      if (info.file.status === "done") {
        this.fileList[0].url = info.file.response.data.filePath;
        this.manuscript.wordCount = info.file.response.data.wordCount;
        this.utils.messageInfo(this, "success", "上传成功");
      } else if (info.file.status == "removed") {
        this.fileList = [];
        this.manuscript.wordCount = 0;
      } else if (info.file.status === "error") {
        this.utils.messageInfo(this, "error", "上传失败");
      }
    },
    previewFile(file) {
      window.open(this.$config.serviceAddress + file.url);
    },
    previous() {
      this.currentStep--;
    },
    next() {
      if (!this.selAuthorCode) {
        this.utils.messageInfo(this, "error", "请确认作者信息！");
        return;
      }
      if (!this.bankCard.openBank || this.bankCard.openBank == "") {
        this.utils.messageInfo(this, "error", "请确认作者银行卡信息！");
        return;
      }
      if (this.currentStep == 0 && this.authorData.length == 0) {
        this.authorData.push({
          ...this.selAuthor,
          authorSort: 1,
          sort: "第1作者",
          corAuthor: 1,
        });
      }
      if (this.currentStep == 1) {
        this.$refs.manuscriptForm.validate((valid) => {
          if (valid) {
            if (this.fileList.length == 0) {
              this.utils.messageInfo(this, "error", "请上传稿件！");
              return;
            }
            if (
              (this.manuscript.sectionInfo == "小学课程版（A）" ||
                this.manuscript.sectionInfo == "中学课程版（B）") &&
              this.manuscript.discipline == ""
            ) {
              this.utils.messageInfo(this, "error", "学科不能为空！");
              return;
            }
            this.currentStep++;
          }
        });
      } else {
        this.currentStep++;
      }
    },
    onSectionChange(val) {
      if (val) {
        this.columnInfos = [
          ...this.allColumnInfos.filter((item) => item.sectionInfo == val),
        ];

        let code = this.sectionInfos.find(
          (item) => item.dicValue == val
        ).dicCode;
        this.axios
          .get("/sectionDisciplineRel/listSectionDisciplineRel", {
            params: { sectionCode: code },
          })
          .then((res) => {
            this.disciplines = [];
            if (res.data.data) {
              res.data.data.forEach((item) => {
                this.disciplines.push({
                  dicCode: item.disciplineCode,
                  dicValue: item.disciplineName,
                });
              });
            } else {
              this.utils.messageInfo(this, "error", "查询刊物学科失败！");
            }
          });
        this.manuscript.discipline = "";
      }
    },
    submit() {
      if (this.authorData.length == 0) {
        this.utils.messageInfo(this, "error", "请添加作者信息！");
        return false;
      }
      if (this.authorData.filter((item) => item.corAuthor === 1).length == 0) {
        this.utils.messageInfo(this, "warning", "请至少选择一个通讯作者！");
        return false;
      }

      //附件
      var fileList = [];
      for (var i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].response.code == "OK") {
          fileList.push(this.fileList[i].response.data);
        }
      }

      this.isloading = true;

      this.axios
        .post("/manuscripts/saveManuscripts", {
          //稿件信息
          cnTitle: this.manuscript.cnTitle,
          wordCount: this.manuscript.wordCount,
          note: this.manuscript.note,
          authorCode: this.selAuthorCode,
          bankCardId: this.bankCard.newCard ? 0 : this.manuscript.bankCardId,
          subtitle: this.manuscript.subtitle,
          summary: this.manuscript.summary,
          keyWords: this.manuscript.keyWords,
          subjectInfo: this.manuscript.subjectInfo,
          referencesInfo: this.manuscript.referencesInfo,
          sectionInfo: this.manuscript.sectionInfo,
          columnInfo: this.manuscript.columnInfo,
          discipline: this.manuscript.discipline,

          //稿件文件
          fileList: JSON.stringify(fileList),

          //稿件作者信息
          authorData: JSON.stringify(this.authorData),

          //银行卡信息
          openBank: this.bankCard.openBank,
          bankCode: this.bankCard.bankCode,
          bankCard: this.bankCard.bankCard,
          idCard: this.bankCard.idCard,
          isDefault: this.bankCard.isDefault ? 1 : 0,

          // 当前责编
          editorCode: sessionStorage.getItem("userCode"),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "提交成功");
            this.$emit("importClose");
          } else {
            this.utils.messageInfo(this, "error", "保存稿件信息失败！");
          }
          this.isloading = false;
        });
    },
    isCor(checked) {
      this.authorInfo.corAuthor = checked ? 1 : 0;
    },
    authorSubmit() {
      this.$refs.newAuthorForm.validate((valid) => {
        if (valid) {
          if (!this.utils.isPhone(this.authorInfo.phone)) {
            this.$message.error("请输入有效的手机号");
            return false;
          }
          if (
            this.authorInfo.email &&
            !this.utils.isEmail(this.authorInfo.email)
          ) {
            this.$message.error("请输入有效的邮箱");
            return false;
          }
          if (this.addAuthorType == "add") {
            let formData = {
              ...this.authorInfo,
              eduLevel: "0",
              status: 1,
              creater: sessionStorage.getItem("userCode"),
            };
            delete formData.corAuthor;
            this.axios.post("/author/saveAuthor", formData).then((res) => {
              if (res.data.code == "OK") {
                this.utils.messageInfo(this, "success", "添加成功");
                this.authorList.push({
                  ...formData,
                  authorCode: res.data.data,
                });
                this.handleChangeAuthor(res.data.data);
              } else {
                this.utils.messageInfo(this, "error", res.data.data);
              }
            });
          } else if (this.addAuthorType == "manuscript") {
            if (this.authorInfo.corAuthor == 1) {
              this.authorData.forEach((item) => {
                if (item.corAuthor == 1) {
                  item.corAuthor = 0;
                }
              });
            }
            this.authorInfo.authorSort = this.authorData.length + 1;
            this.authorInfo.sort = "第" + this.authorInfo.authorSort + "作者";
            this.authorData.push({ ...this.authorInfo });
          } else if (this.addAuthorType == "edit") {
            for (var i = 0; i < this.authorData.length; i++) {
              if (this.authorData[i].authorSort == this.authorInfo.authorSort) {
                this.authorData.splice(i, 1, { ...this.authorInfo });
                break;
              }
            }
          }
          this.authorInfo = {
            authorName: "",
            sex: 1,
            birth: "",
            professionalTitle: "", //职称
            studyDirection: "", //研究方向
            province: "",
            city: "",
            postCode: "",
            companyName: "",
            companyAddress: "",
            phone: "",
            email: "",
            corAuthor: 0,
          };
          this.visible = false;
        }
      });
    },
    deleteAuthor(authorInfo) {
      for (var i = 0; i < this.authorData.length; i++) {
        if (this.authorData[i].authorSort == authorInfo.authorSort) {
          this.authorData.splice(i, 1);
        }
      }
      for (var j = 0; j < this.authorData.length; j++) {
        this.authorData[j].sort = "第" + (j + 1) + "作者";
        this.authorData[j].authorSort = j + 1;
      }
    },
    addAuthor(type) {
      this.addAuthorType = type;
      this.modelTitle = "新增作者";
      this.visible = true;
    },
    orderUp(authorSort) {
      if (authorSort > 1) {
        var data = this.authorData[authorSort - 1];
        data.sort = "第" + (authorSort - 1) + "作者";
        data.authorSort = authorSort - 1;
        var perData = this.authorData[authorSort - 2];
        perData.sort = "第" + authorSort + "作者";
        perData.authorSort = authorSort;
        this.authorData.splice(authorSort - 1, 1, perData);
        this.authorData.splice(authorSort - 2, 1, data);
      }
    },
    orderDown(authorSort) {
      if (authorSort < this.authorData.length) {
        var data = this.authorData[authorSort - 1];
        data.sort = "第" + (authorSort + 1) + "作者";
        data.authorSort = authorSort + 1;
        var nextData = this.authorData[authorSort];
        nextData.sort = "第" + authorSort + "作者";
        nextData.authorSort = authorSort;
        this.authorData.splice(authorSort - 1, 1, nextData);
        this.authorData.splice(authorSort, 1, data);
      }
    },
    editAuthor(authorInfo) {
      this.authorInfo = { ...authorInfo };
      this.addAuthorType = "edit";
      this.modelTitle = "编辑作者";
      this.visible = true;
    },
    downloadFile(url) {
      window.open(this.$config.serviceAddress + url);
    },
  },
};
</script>

<style scoped>
</style>
